module.exports = __webpack_public_path__ + "news-4a753f38/404-6b5a631fccc0149f72dd5d37e01692c7.svg";